import {
  GET_PRE_REGISTRATION_CONFIGURATIONS,
  GET_PRE_REGISTRATION_CONFIGURATIONS_FAIL,
  GET_PRE_REGISTRATION_CONFIGURATIONS_SUCCESS,
  ADD_NEW_PRE_REGISTRATION_CONFIGURATION,
  ADD_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
  ADD_PRE_REGISTRATION_CONFIGURATION_FAIL,
  UPDATE_PRE_REGISTRATION_CONFIGURATION,
  UPDATE_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
  UPDATE_PRE_REGISTRATION_CONFIGURATION_FAIL,
  DELETE_PRE_REGISTRATION_CONFIGURATION,
  DELETE_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
  DELETE_PRE_REGISTRATION_CONFIGURATION_FAIL,
  
} from "./actionTypes";

export const getPreRegistrationConfigurations = () => ({
  type: GET_PRE_REGISTRATION_CONFIGURATIONS,
})

export const getPreRegistrationConfigurationsSuccess = preRegistrationConfigurations => ({
  type: GET_PRE_REGISTRATION_CONFIGURATIONS_SUCCESS,
  payload: preRegistrationConfigurations,
})

export const getPreRegistrationConfigurationsFail = error => ({
  type: GET_PRE_REGISTRATION_CONFIGURATIONS_FAIL,
  payload: error,
})

export const addNewPreRegistrationConfiguration = data => ({
  type: ADD_NEW_PRE_REGISTRATION_CONFIGURATION,
  payload: data,
})

export const addPreRegistrationConfigurationSuccess = preRegistrationConfiguration => ({
  type: ADD_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
  payload: preRegistrationConfiguration,
})

export const addPreRegistrationConfigurationFail = error => ({
  type: ADD_PRE_REGISTRATION_CONFIGURATION_FAIL,
  payload: error,
})

export const updatePreRegistrationConfiguration = preRegistrationConfiguration => ({
  type: UPDATE_PRE_REGISTRATION_CONFIGURATION,
  payload: preRegistrationConfiguration,
})

export const updatePreRegistrationConfigurationSuccess = preRegistrationConfiguration => ({
  type: UPDATE_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
  payload: preRegistrationConfiguration,
})

export const updatePreRegistrationConfigurationFail = error => ({
  type: UPDATE_PRE_REGISTRATION_CONFIGURATION_FAIL,
  payload: error,
})

export const deletePreRegistrationConfiguration = data => ({
  type: DELETE_PRE_REGISTRATION_CONFIGURATION,
  payload: data,
})

export const deletePreRegistrationConfigurationSuccess = data => ({
  type: DELETE_PRE_REGISTRATION_CONFIGURATION_SUCCESS,
  payload: data,
})

export const deletePreRegistrationConfigurationFail = error => ({
  type: DELETE_PRE_REGISTRATION_CONFIGURATION_FAIL,
  payload: error,
})

